import { Flex } from '@styles';
import styled from 'styled-components';

export const scenarioPageLayoutByVariant = {
  desktop: {
    pl: 156,
    pr: 156,
    px: 156,
  },
  mobile: {
    pl: 156,
    pr: 156,
    px: 156,
  },
};

export const Container = styled(Flex)`
  background-blend-mode: overlay;
`;
